import { useRender } from "@base-ui-components/react/use-render";
import { mergeProps } from "@base-ui-components/react/merge-props";
import { boxClasses, BoxVariants } from "./Box.style";
import { ElementType } from "react";

export type BoxProps = useRender.ComponentProps<"div"> &
  BoxVariants & {
    component?: ElementType;
  };

function Box(props: BoxProps) {
  const {
    render,
    flex,
    flexDirection,
    justifyContent,
    alignItems,
    p,
    bordered,
    rounded,
    className,
    children,
    m,
    mb,
    ml,
    mr,
    mt,
    mx,
    my,
    ...rest
  } = props;

  const element = render ?? <div />;

  const defaultProps: useRender.ElementProps<"div"> = {
    children,
    className: boxClasses({
      flex,
      flexDirection,
      p,
      bordered,
      rounded,
      m,
      mb,
      ml,
      mr,
      mt,
      mx,
      my,
      justifyContent,
      alignItems,
      class: className,
    }),
  };

  const renderElement = useRender({
    render: element,
    props: mergeProps<"div">(defaultProps, rest),
  });

  return renderElement;
}

export default Box;
